import {
  BooleanInput,
  Create,
  CreateContextProvider,
  Edit,
  EditContextProvider,
  Form,
  required,
  SaveButton,
  SelectInput,
  TextInput,
  Toolbar,
  TopToolbar,
  useCreateController,
  useEditController,
  useNotify,
  useRedirect,
  useRefresh,
  useTranslate,
} from 'react-admin';
import {
  Box,
  Card,
  Divider,
  Stack,
  Typography,
  Button as MUIButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Resources } from '../resource';
import AgentsForm from './AgentsForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const EditAgents = ({ id, onClose }: { id: string | number; onClose: () => void }) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useEditController({
    id,
    resource: Resources.agents,
    mutationMode: 'pessimistic',
    mutationOptions: {
      onSuccess: () => {
        notify(t('module.agents.updateSuccess'), { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        const errorCode = error?.body?.code || error?.code;
        switch (errorCode) {
          default:
            // notify(t('module.agents.unknownErrorUpdate'), { type: 'error' });
            refresh();
            onClose();
            break;
        }
      },
    },
  });

  if (controller.isLoading || !controller.record) return null;

  return (
    <EditContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>{t('module.agents.editAgents')}</DialogTitle>
        <DialogContent>
          <AgentsForm isCreate={false} />
        </DialogContent>
        <DialogActions>
          <MUIButton
            variant="outlined"
            onClick={() => {
              onClose();
            }}
          >
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="agents" action="update">
            <SaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </EditContextProvider>
  );
};

export default EditAgents;
